<template>
  <!-- my profile screen, shows the data of the logged in user and possible edits -->

  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="PixPaymentModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header mb-5">
          <h5 class="text-center text-join">PIX</h5>
          <button
            type="button"
            class="close"
            id="closePixModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" class="close-mobile">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="class-desktop">
            <div
              class="col-12"
              v-if="!pixValues.pix_base64"
              style="display: flex; justify-content: center"
            >
              <img src="static/img/pix.gif" style="width: 400px" />
            </div>
            <div v-else class="col-12" style="display: flex; margin-top: -55px">
              <div class="col-6">
                <img
                  :src="'data:image/png;base64,' + pixValues.pix_base64"
                  alt="QRCode"
                  style="width: 250px"
                  class="justify-center"
                />

                <div class="footer-pix" style="margin-left: 25px">
                  <div class="style-font"  v-if="pixValues.pix_dt_vencto">
                    <span>Você pode pagar com esse QR Code</span><br />
                    <span style="margin-left: 25px">
                      até {{ pixValues.pix_dt_vencto | formatDate }} às {{ pixValues.pix_dt_vencto | formatHour }}
                    </span
                    >
                  </div>

                  <div class="row-6 pix-copy-qr mt-2" style="margin-left: 40px">
                    <button
                      type="button"
                      id="copyQRCode"
                      class="btn pix-copy-qr-btn"
                      @click="copyCodePix(pixValues.pix_emv)"
                    >
                      Copiar QR Code
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-8 mt-4" style="margin-left: -12%">
                <div class="style-font-info">
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Inscrição cedente:</span
                    >
                    <span class="span-pix-info">
                      {{ bill.ced_inscricao | formatCPFCNPJ }}
                    </span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Cedente:</span
                    >
                    <span class="span-pix-info"> {{ bill.cedente }}</span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Inscrição pagador:</span
                    >
                    <span class="span-pix-info">
                      {{ bill.sac_inscricao | formatCPFCNPJ }}</span
                    >
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Pagador:</span
                    >
                    <span class="span-pix-info"> {{ bill.sacado }}</span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Documento:</span
                    >
                    <span class="span-pix-info">{{ bill.num_docto }}</span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Nosso número:</span
                    >
                    <span class="span-pix-info">{{ bill.nosso_numero }}</span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Vencimento:</span
                    >
                    <span class="span-pix-info">
                      {{ bill.cod_dt_vencto | formatDate }}
                    </span>
                  </div>
                  <div class="row row-pix-info">
                    <span class="span-pix-info-title"
                      >Valor a pagar:</span
                    >
                    <span class="span-pix-info">
                      {{ pixValues.pix_valor | formatCurrency }}</span
                    >
                  </div>
                </div>
                <div class="row style-font mt-4 border-primary">
                  <span style="width: 100%; color: #898585" class="mb-2 mt-2">
                    Siga os passos:
                  </span>
                  <br>
                    <span
                    ><span class="use-qr-code-number">1.</span> Abra o app do
                      seu banco;</span
                    >
                  <span
                  ><span class="use-qr-code-number">2.</span> Busque a opção
                      de pagamento com QR Code e escaneie o código acima;</span
                  >
                  <span
                  ><span class="use-qr-code-number">3.</span> Revise as
                      informações e confirme o pagamento;</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="class-mobile">
            <div
              class="col-12"
              v-if="!pixValues.pix_base64"
              style="display: flex; justify-content: center"
            >
              <img src="static/img/pix.gif" style="width: 400px" />
            </div>
            <div
              v-else
              class="col-12"
              style="display: flex; margin-top: -55px; padding: 0px"
            >
              <div class="col-6">
                <img
                  :src="'data:image/png;base64,' + pixValues.pix_base64"
                  alt="QRCode"
                  style="width: 150px"
                />
                <div class="row style-font justify-center style-time-ipad" v-if="pixValues.pix_dt_vencto">
                  <span>QR Code válido até </span>
                  <span>{{ pixValues.pix_dt_vencto | formatDate }} às 23:59</span>
                </div>
              </div>

              <div class="col-6">
                <div>
                  <span
                    class="mt-4"
                    style="
                      font-size: 20px;
                      display: flex;
                      justify-content: center;
                      color: rgb(100, 95, 95);
                    "
                  >
                    {{ pixValues.pix_valor | formatCurrency }}</span
                  ><br />

                  <div class="justify-center">
                    <button
                      id="copyQRCodeMobile"
                      type="button"
                      class="btn pix-copy-qr-btn"
                      @click="copyCodePix(pixValues.pix_emv)"
                    >
                      Copiar QR Code
                    </button>
                  </div>
                  <div class="style-number-ipad">
                    <span
                      style="
                        font-size: 11px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 11ch;
                        color: rgb(100, 95, 95);
                      "
                      >Nosso número: {{ bill.nosso_numero }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import BillsAction from "../bill/BillsAction";

export default {
  name: "PixPaymentModal",
  data() {
    return {
      billsAction: new BillsAction(),
      pixValues: {},
    };
  },
  props: ["pix", "bill"],

  methods: {
    copyCodePix: function (pixCode) {
      return BillsAction.copy(pixCode);
    },

    getPixModal: function () {
      BillsAction.getPix(this.bill.cod_id)
        .then((response) => {
          if (response) {
            this.$emit("addPixArray", response);
            this.pixValues = response;

            return;
          }
        })
        .catch((err) => {
          this.$emit("allowGetPix");

          Vue.$toast.error("Ops! Não foi possível completar a ação.", {
            position: "top-right",
            duration: 5000,
          });
          $("#PixPaymentModal").modal("hide");
        });
    },
  },
  mounted() {
    $("#PixPaymentModal").modal("show");

    if (!this.pix.pix_base64) {
      return this.getPixModal();
    }
    this.pixValues = this.pix;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 46%;
}
.style-font {
  font-size: 13px;
  color: rgb(100, 95, 95);
}
.style-font-info {
  font-size: 16px;
  color: rgb(100, 95, 95);
}
.justify-center {
  display: flex;
  justify-content: center;
}
.pix-copy-qr-btn {
  font-size: 12px;
  color: #fff;
  background-color: #18cab9;
}

.span-pix-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
  font-size: 0.9rem;
  align-self: center;
}

.span-pix-info-title {
  min-width: 160px;
  color: #898585;
}

.use-qr-code-number {
  color: #424242;
}
.class-mobile {
  display: none !important;
}
@media only screen and (max-width: 767px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 45%;
  }
  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }

  .style-time-ipad {
    padding-left: 0 !important;
  }
  .style-number-ipad {
    margin-right: 0 !important;
  }

  .modal-content {
    width: 112%;
    margin-left: -28px;
    opacity: 0.9;
  }
  .modal-dialog {
    margin-top: 90%;
  }
}
@media only screen and (max-width: 800px) and (min-width: 768px) {
  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }
  .style-number-ipad {
    padding-left: 30px !important ;
  }
  .style-time-ipad {
    margin-right: 23% !important;
  }
}

@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/home/pix/PixPaymentModal.vue